import classNames from '@/lib/ClassName';
import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { ChevronDownIcon } from 'lucide-react';

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/_tabs/details/$detailsTab',
)({
  component: RouteComponent,
  loader: async ({ context: { queryClient }, params }) => {

    const { entity_type_id, entity_id } = params;
    await queryClient.ensureQueryData(getEntityQueryOptions(entity_type_id, entity_id));
  }
})

function RouteComponent() {
  const { entity_type_id, entity_id, module_id } = Route.useParams();
  const { data: result } = useQuery(getEntityQueryOptions(entity_type_id, entity_id));


  const tabs: { name: string, to: string }[] = result?.view?.tabs?.map(tab => ({
    name: tab.name as string,
    to: `/_app/${module_id}/${entity_type_id}/${entity_id}/details/${tab.name?.toLowerCase().replace(/ /g, "-")}`,

  })) ?? [];

  if (!result || !result?.view || !tabs) {
    return <div>Error</div>
  }
  if (tabs.length === 0) {
    return <div>No tabs</div>
  }


  return (
    <div className="w-full h-full overflow-y-auto">
      {tabs.length > 1 && <div className="border-b border-gray-200 bg-white ">
        <div className="grid grid-cols-1 sm:hidden">
          {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
          <select

            aria-label="Select a tab"
            className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          >
            {tabs.map((tab) => (
              <option key={tab.name}>{tab.name}</option>
            ))}
          </select>
          <ChevronDownIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
          />
        </div>
        <div className="hidden sm:block">
          <nav aria-label="Tabs" className="isolate flex divide-x divide-gray-200">
            {tabs.map((tab, tabIdx) => (
              <Link
                key={tab.name}
                to={'/$module_id/$entity_type_id/$entity_id/details/$detailsTab'}
                params={{
                  module_id,
                  entity_type_id,
                  entity_id,
                  detailsTab: tab.name?.toLowerCase().replace(/ /g, "-"),
                }}

                replace={true}
                className={classNames(
                  'text-gray-500 hover:text-gray-700',
                  tabIdx === 0 ? '' : '',
                  tabIdx === tabs.length - 1 ? '' : '',
                  'group relative min-w-0 flex-1 overflow-hidden bg-white px-4 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10',
                )}
                activeProps={{
                  className: 'text-gray-900 bg-white border-r-gray-200 border-blue-500 font-medium border-b-2',
                }}
              >
                <span>{tab.name}</span>

              </Link>
            ))}
          </nav>
        </div>
      </div>}

      <Outlet />
    </div>
  );
}
